<template>
    <router-link class="text-link" :to="link.href">{{ link.text }}</router-link>
</template>

<script>
export default {
    name: "TextLink",
    props: {
        link: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.text-link {
    color: #4858cf;
    text-decoration: none;
    font-weight: 800;
    font-size: 1.2rem;
    cursor: pointer;
}
</style>